module.exports = __webpack_public_path__ + "img/white-trash.778cd00e.svg";